import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import { Button, Form, FormGroup, FormText, Input, Label, Table } from 'reactstrap';
import { GoCheck } from 'react-icons/go';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';

class HeadCoaches extends Component {
    static displayName = HeadCoaches.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            //globalLevel: "",
            level: this.props.reduxData.userInfo.level.pk,
            sports: [".", ","],            
            coaches: [],
            activeData: [".", ","],
            addSuccess: false,
            deleteSuccess: false,
            permissionFlag: true
        }
        this.findActive();
        this.testPermission();
    }

    async getData() {
        const response = await axios.get('https://geolocation-db.com/json/');
        this.setState({
            ip: response.data.IPv4
        });
        this.getUserInfo();
    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //this.props.updateFetchTime();
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            //returnable: this.props.reduxData.userInfo,
            loading: false,
            //username: this.props.reduxData.userInfo.username,
        }, () => { this.findActive(); });//We can go get the list of active coaches immediately before waiting for the test permission function to resolve. AuthN/AuthZ is happening within the controller
        //so if the user would fail the test permission function they'll fail this check as well.
        this.findActive();
        this.setState({
            level: this.props.ourLevel
        });
        //var dept = this.props.reduxData.userInfo.level.pk
        //dept = dept.substring(0, (dept.indexOf('-') - 1));
        //this.recordComingHere();
        this.testPermission();
    }

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "1021"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
        this.findSports();
    }

    async recordComingHere() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            pagePK: "1021",
            department: this.props.reduxData.userInfo.level.pk,
            userPCID: this.props.reduxData.userInfo.pcid,
            ip: this.state.ip,
            browser: this.state.browser,
            userID: this.props.reduxData.userInfo.username
        }
        const response = await fetch('logging', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.findSports();//Hopefully, after waiting this long, the state value for the user information will have resolved. If you notice it hasn't, put this in a callback within a this.setState({}) earlier.
    }

    async findSports() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('sports', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            sports: data
        })
    }

    async filterCoaches(e) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            sport: e.target.value,
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('coaches', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            coaches: data
        })
    }

    async addNew(e) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const dataInput = new FormData(e.target);
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            sport: dataInput.get('sport'),
            coach: dataInput.get('coach')
        }
        const response = await fetch('AddCoach', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            addSuccess: data
        }, () => {console.log("set state callback works") })
        setTimeout(() => {
            this.setState({
                addSuccess: false
            })
        }, 4000)//We will make sure no matter what the success status of the Add New attempt was, we clear out the feedback message after four seconds
        this.findActive();
    }

    async findActive() {
        console.log("findActive")
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('AssociationHeads', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            activeData: data
        })
    }

    async deleteCoach(pk) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pk: pk
        }
        const response = await fetch('deleteCoach', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            deleteSuccess: data
        })
        this.findActive();
    }

    componentDidMount() {

    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
            return (//Note: UserContext really isn't useful anymore, but the process of removing it only from the places that don't need it will require its own mini-project. To-do list for now.
                <UserContext.Consumer>
                    {contextData => (
                        <div>
                            <Form className='d-flex' onSubmit={this.addNew.bind(this)}>
                                <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                    <Label className="mr-sm-2">Sport</Label>
                                    <Input type="select" name="sport" id="sport" onChange={this.filterCoaches.bind(this)} defaultValue="DEFAULT">
                                        <option disabled={true} value="DEFAULT">Select...</option>
                                        {this.state.sports.map(sportNames => (
                                            <option>{sportNames}</option>
                                            ))}
                                    </Input>
                                </FormGroup>
                                <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                    <Label className="mr-sm-2">Coach</Label>
                                    <Input type="select" name="coach" id="coach" defaultValue="0">
                                        <option value="0" disabled={true}>{this.state.coaches.length == 0 ? "Please pick a sport" : "Select..."}</option>
                                        {this.state.coaches.map(coachNames => (
                                            <option value={coachNames.pcid} hidden={coachNames.pcid == "P000042069" ? true : false }>{coachNames.name}</option>
                                            ))}
                                    </Input>
                                </FormGroup>
                                <Button type="submit">Submit</Button>&emsp;<div style={{ visibility: this.state.addSuccess == true ? 'visible' : 'hidden' }}> Success! <GoCheck style={{ visibility: this.state.addSuccess == true ? 'visible' : 'hidden' }} /></div>
                            </Form>
                            <br />
                            <Table striped>
                                <thead>
                                    <tr>
                                        <th className="w-45" style={{ textAlign: 'right' }}>Sport</th>
                                        <th className="w-45">Coach</th>
                                        <th className="w-10"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.activeData.map(headCoaches => (
                                        <tr>
                                            <td className="w-45" style={{ textAlign: 'right' }}>{headCoaches.sport}</td>
                                            <td className="w-45">{headCoaches.name}</td>
                                            <td className="w-10"><Button outline color="danger" size="sm" onClick={() => this.deleteCoach(headCoaches.pk)}>Delete</Button></td>
                                        </tr>
                                        ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </UserContext.Consumer>
            );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(HeadCoaches);